"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * ** Tabs organise content across different screens, data sets, and other interactions. **
 *
 * Tabs keeps related content in a single container that is shown and hidden through navigation. Content is separated into different panes, and each pane is viewable one at a time.
 * When it is used with Circular tab, Simple tab can be used at both higher or lower level.
 */
var TabsSimple = function TabsSimple(_ref) {
  var tabs = _ref.tabs,
      selected = _ref.selected,
      centered = _ref.centered,
      action = _ref.action;
  return /*#__PURE__*/_react.default.createElement(_core.Tabs, {
    value: selected,
    indicatorColor: "primary",
    onChange: function onChange(event, newValue) {
      return action(newValue);
    },
    centered: centered,
    variant: !centered && "scrollable"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement(_core.Tab, {
      key: tab,
      label: tab
    });
  }));
};

TabsSimple.propTypes = {
  /** Array of strings for values of the tabs  */
  tabs: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,

  /** The index of the tab that will have the selected state   */
  selected: _propTypes.default.number,

  /** Center the tabs in the available space  */
  centered: _propTypes.default.bool,

  /** Callback fired when the value changes. function(value: any) => void  */
  action: _propTypes.default.func.isRequired
};
TabsSimple.defaultProps = {
  selected: 0,
  centered: true
};
var _default = TabsSimple;
exports.default = _default;